export default __webpack_public_path__ + "static/media/ContentLibraryLightActive.bdb506e5.svg";